import { useMediaQuery } from "@/lib/hooks/useMediaQuery";
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "./ui/resizable";
import { useState } from "react";
import { Button } from "./ui/button";
import { ArrowLeft } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

function SplitPane(props: {
  children: [React.ReactElement, React.ReactElement];
  showResultPanel: boolean;
}) {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const [showResults, setShowResults] = useState(props.showResultPanel);

  if (isDesktop) {
    return (
      <ResizablePanelGroup direction="horizontal" className="w-full">
        <ResizablePanel
          maxSize={75}
          minSize={25}
          defaultSize={40}
          className="bg-card flex flex-col @container h-full"
        >
          <div className="flex flex-col h-full overflow-y-auto max-h-dvh">
            {props.children[0]}
          </div>
        </ResizablePanel>
        <ResizableHandle withHandle />
        <ResizablePanel
          maxSize={75}
          minSize={25}
          defaultSize={60}
          className="flex flex-col bg-card"
        >
          <div className="sticky top-0 flex flex-col h-full overflow-y-auto max-h-dvh">
            {props.children[1]}
          </div>
        </ResizablePanel>
      </ResizablePanelGroup>
    );
  }

  return (
    <div
      className={cn(
        "flex flex-col px-4 py-2 overflow-y-auto",
        showResults ? "bg-inherit max-h-[80vh] h-full" : "bg-card"
      )}
    >
      {showResults && (
        <Button
          onClick={() => setShowResults(false)}
          className="mb-1"
          variant="secondary"
        >
          <ArrowLeft />
          <span className="ml-2">Back</span>
        </Button>
      )}
      {showResults ? props.children[1] : props.children[0]}
    </div>
  );
}

export default SplitPane;
